import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/smanga-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-26843fb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['logo','posted'])
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [..._hoisted_3]))
}